export default __webpack_public_path__ + "static/1167-b56f3a7957afee7ab61f5c2b58e8b47d.gif";